import React from 'react'

import style from '../../../styles/Weather/weather_weekly_conditions'
import Title from '../Title'
import WeekDay from './WeekDay'

const WeatherWeeklyConditions = ({ forecast }) => {
  return (
    <div className='wrapper'>
      <Title title='10 day forecast' />
      <div className='container-weather'>
        <div className='container-weekly-conditions'>
          {forecast?.map((day, index) => (
            <WeekDay day={day} key={index} />
          ))}
        </div>
      </div>
      <style jsx>{style}</style>
    </div>
  )
}

export default WeatherWeeklyConditions
